import { XCircleIcon } from '@heroicons/react/24/outline';

interface RejectionNoticeProps {
    note?: string | null;
}

export function RejectionNotice({ note }: RejectionNoticeProps) {
    if (!note) return null;

    return (
        <div className="mt-2 flex gap-2 rounded-xl border border-red-200 bg-red-50 p-3">
            <XCircleIcon className="h-4 w-4 shrink-0 text-red-600" aria-hidden="true" />
            <p className="text-xs text-red-900 font-montserrat">
                <span className="font-semibold">Motivo da reprovação:</span> {note}
            </p>
        </div>
    );
}

export default RejectionNotice;
